<template>
    <div class="home position-relative">
        <Map
            :latCenter="48.22830617300693"
            :lngCenter="17.402899096256306"
        ></Map>
    </div>
</template>

<script>
import Map from "../../components/private/Map";

export default {
    data() {
        return {};
    },
    methods: {},
    mounted() {},
    components: {
        Map
    }
};
</script>
